export const pharmaciesKeysForTitleAndDescription = {
  buyRu: 'Купить',
  buyUa: 'Купити',
  buyRuSmall: 'купить',
  buyUaSmall: 'купити',
  in: 'в',
  pricesInPharmaciesRu: 'цены в аптеках',
  pricesInPharmaciesUa: 'ціни в аптеках',
  priceInPharmaciesRu: 'цена в аптеках',
  priceInPharmaciesUa: 'ціна в аптеках',
  affordablePriceRu: 'по доступной цене',
  affordablePriceUa: 'за доступною ціною',
  instructionsBookingRu: 'Инструкция и онлайн бронирование в аптеках',
  instructionsBookingUa: 'Інструкція та онлайн бронювання в аптеках',
  actualPricesRu: 'наличие препарата в аптеках и актуальные цены - адреса и телефоны аптек, купить препарат в аптеке',
  actualPricesUa: 'наявність препарату в аптеках та актуальні ціни - адреси та телефони аптек, купити препарат в аптеці'
}
